import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema, setInModel } from 'i2g-ng-utils';
import { JobEstimateLink } from './job-estimate-link.model';

export const JOB_ESTIMATE_SCHEMA = Object.freeze({
  DOCUMENT_ID: null,
  REVISION_ID: null,
  DOCUMENT_NUMBER: null,
  APPROVED: false,
  APPROVAL_DATE: null,
  LINKED_INVOICE_DOC_DATE: null,
  LINKED_INVOICE_DOC_NUMBER: null,
  LINKS: JobEstimateLink,
});
const RECORD = generateSchema(JOB_ESTIMATE_SCHEMA);
const KEYS: any = generateKeys(JOB_ESTIMATE_SCHEMA);

export class JobEstimate extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.LINKS,
        value: props.get(KEYS.LINKS) ? new JobEstimateLink(this.links) : null,
      },
    ]);

    return selfModel as JobEstimate;
  }

  get documentId(): string {
    return this.get(KEYS.DOCUMENT_ID);
  }

  get revisionId(): string {
    return this.get(KEYS.REVISION_ID);
  }

  get documentNumber(): string {
    return this.get(KEYS.DOCUMENT_NUMBER);
  }

  get links(): JobEstimateLink {
    return this.get(KEYS.LINKS);
  }

  get approved(): boolean {
    return this.get(KEYS.APPROVED);
  }

  get approvalDate(): string {
    return this.get(KEYS.APPROVAL_DATE);
  }

  get linkedInvoiceDocDate(): string {
    return this.get(KEYS.LINKED_INVOICE_DOC_DATE);
  }

  get linkedInvoiceDocNumber(): string {
    return this.get(KEYS.LINKED_INVOICE_DOC_NUMBER);
  }
}
